import React, { ReactElement, ReactNode } from "react"
import Helmet from "react-helmet"
import { Link as GatsbyLink } from "gatsby"
import { NavLink, NavSmallLink, Link } from "./Link"

interface Props {
  children: ReactNode
}

function LayoutWrapper({ children }: Props): ReactElement {
  return (
    <>
      <Helmet>
        <html className="antialiased bg-white" />
      </Helmet>
      <div className="bg-page">
        <div className="container pb-16 mx-auto">
          <header className="inset-x-0 flex items-center border-b-2 border-blue-200">
            <div className="w-full max-w-screen-xl px-4 md:px-0">
              <div className="flex flex-col justify-center h-24">
                <div className="flex items-center -mx-4">
                  <div className="pl-6 pr-6 lg:w-1/4 xl:w-1/5">
                    <div className="flex items-center">
                      <GatsbyLink to="/" className="block">
                        <svg
                          className="block w-10 h-10 md:hidden"
                          xmlns="http://www.w3.org/2000/svg"
                          width="121px"
                          height="119px"
                          viewBox="0 0 121 119"
                          version="1.1"
                        >
                          <title>Bahá’í Gemeinde Mannheim</title>
                          <g
                            id="Page-1"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="Mannheim_Water_Tower_Symbol_Final-Kopie"
                              transform="translate(-187.000000, -75.000000)"
                              fill="#0072A6"
                            >
                              <g
                                id="Logo"
                                transform="translate(187.542000, 75.175000)"
                              >
                                <polyline
                                  id="Fill-1"
                                  points="60.096 31.879 44.156 15.94 60.096 0 76.036 15.939 60.096 31.879"
                                />
                                <polyline
                                  id="Fill-2"
                                  points="41.362 38.697 18.906 36.733 20.871 14.277 43.327 16.241 41.362 38.697"
                                />
                                <polyline
                                  id="Fill-3"
                                  points="31.394 55.963 12.929 68.892 0 50.426 18.464 37.497 31.394 55.963"
                                />
                                <polyline
                                  id="Fill-4"
                                  points="34.856 75.596 29.022 97.37 7.248 91.535 13.082 69.762 34.856 75.596"
                                />
                                <polyline
                                  id="Fill-5"
                                  points="50.128 88.411 59.654 108.84 39.225 118.367 29.698 97.938 50.128 88.411"
                                />
                                <polyline
                                  id="Fill-6"
                                  points="70.064 88.411 90.494 97.937 80.967 118.367 60.538 108.841 70.064 88.411"
                                />
                                <polyline
                                  id="Fill-7"
                                  points="85.336 75.596 107.11 69.761 112.944 91.536 91.17 97.37 85.336 75.596"
                                />
                                <polyline
                                  id="Fill-8"
                                  points="88.798 55.962 101.727 37.497 120.193 50.427 107.263 68.892 88.798 55.962"
                                />
                                <polyline
                                  id="Fill-9"
                                  points="78.83 38.697 76.865 16.241 99.321 14.277 101.286 36.733 78.83 38.697"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                        <svg
                          className="hidden w-auto h-16 md:block"
                          xmlns="http://www.w3.org/2000/svg"
                          width="331px"
                          height="90px"
                          viewBox="0 0 331 90"
                          version="1.1"
                        >
                          <title>Bahá’í Gemeinde Mannheim</title>
                          <g
                            id="Page-1"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              id="Mannheim_Water_Tower_Symbol_Final-Kopie"
                              transform="translate(-82.000000, -453.000000)"
                              fill="#0072A6"
                            >
                              <g
                                id="Group-3"
                                transform="translate(82.882000, 453.923000)"
                              >
                                <g id="Group-2">
                                  <polyline
                                    id="Fill-11"
                                    points="45.055 23.899 33.105 11.95 45.056 -5.68434189e-14 57.005 11.949 45.055 23.899"
                                  />
                                  <polyline
                                    id="Fill-12"
                                    points="31.01 29.011 14.175 27.539 15.648 10.703 32.483 12.175 31.01 29.011"
                                  />
                                  <polyline
                                    id="Fill-13"
                                    points="23.537 41.956 9.694 51.648 -3.55271368e-14 37.805 13.844 28.112 23.537 41.956"
                                  />
                                  <polyline
                                    id="Fill-14"
                                    points="26.133 56.674 21.759 72.999 5.434 68.625 9.808 52.3 26.133 56.674"
                                  />
                                  <polyline
                                    id="Fill-15"
                                    points="37.582 66.282 44.724 81.598 29.408 88.74 22.265 73.424 37.582 66.282"
                                  />
                                  <polyline
                                    id="Fill-16"
                                    points="52.529 66.282 67.845 73.423 60.702 88.74 45.387 81.598 52.529 66.282"
                                  />
                                  <polyline
                                    id="Fill-17"
                                    points="63.978 56.674 80.302 52.3 84.676 68.625 68.352 72.999 63.978 56.674"
                                  />
                                  <polyline
                                    id="Fill-18"
                                    points="66.573 41.955 76.266 28.112 90.11 37.805 80.417 51.648 66.573 41.955"
                                  />
                                  <polyline
                                    id="Fill-19"
                                    points="59.1 29.011 57.627 12.176 74.463 10.703 75.936 27.539 59.1 29.011"
                                  />
                                </g>
                                <path
                                  d="M216.723,55.175 L216.723,67.542 L215.051,67.542 L215.051,52.139 L216.811,52.139 L222.685,62.833 L228.56,52.139 L230.233,52.139 L230.233,67.542 L228.56,67.542 L228.56,55.175 L223.104,65.011 L222.18,65.011 L216.723,55.175 Z M208.836,67.542 L210.596,67.542 L210.596,52.139 L208.836,52.139 L208.836,67.542 Z M194.879,67.542 L194.879,52.139 L205.551,52.139 L205.551,53.635 L196.596,53.635 L196.596,58.806 L204.45,58.806 L204.45,60.214 L196.596,60.214 L196.596,66.067 L205.77,66.067 L205.77,67.542 L194.879,67.542 Z M188.747,60.171 L179.616,60.171 L179.616,67.542 L177.899,67.542 L177.899,52.139 L179.616,52.139 L179.616,58.652 L188.747,58.652 L188.747,52.139 L190.441,52.139 L190.441,67.542 L188.747,67.542 L188.747,60.171 Z M162.151,54.626 L162.151,67.542 L160.479,67.542 L160.479,52.139 L162.306,52.139 L171.789,64.88 L171.789,52.139 L173.462,52.139 L173.462,67.542 L171.789,67.542 L162.151,54.626 Z M144.733,54.626 L144.733,67.542 L143.06,67.542 L143.06,52.139 L144.887,52.139 L154.37,64.88 L154.37,52.139 L156.043,52.139 L156.043,67.542 L154.37,67.542 L144.733,54.626 Z M129.755,61.711 L136.246,61.711 L133.012,54.076 L129.755,61.711 Z M140.537,67.542 L138.666,67.542 L136.774,63.097 L129.249,63.097 L127.356,67.542 L125.574,67.542 L132.197,52.139 L133.914,52.139 L140.537,67.542 Z M109.53,55.175 L109.53,67.542 L107.858,67.542 L107.858,52.139 L109.619,52.139 L115.493,62.833 L121.368,52.139 L123.041,52.139 L123.041,67.542 L121.368,67.542 L121.368,55.175 L115.912,65.011 L114.987,65.011 L109.53,55.175 Z M316.91,43.28 L316.91,26.478 L329.271,26.478 L329.271,29.671 L320.583,29.671 L320.583,33.151 L328.071,33.151 L328.071,36.128 L320.583,36.128 L320.583,40.112 L329.512,40.112 L329.512,43.28 L316.91,43.28 Z M302.158,40.112 L304.558,40.112 C306.158,40.112 307.478,39.616 308.518,38.624 C309.558,37.631 310.078,36.383 310.078,34.88 C310.078,33.375 309.558,32.131 308.518,31.147 C307.478,30.163 306.158,29.671 304.558,29.671 L302.158,29.671 L302.158,40.112 Z M304.486,26.478 C307.175,26.478 309.387,27.27 311.123,28.855 C312.858,30.439 313.726,32.431 313.726,34.832 C313.726,37.231 312.839,39.24 311.062,40.856 C309.286,42.472 307.055,43.28 304.366,43.28 L298.485,43.28 L298.485,26.478 L304.486,26.478 Z M282.806,31.951 L282.806,43.28 L279.23,43.28 L279.23,26.478 L283.023,26.478 L290.775,37.519 L290.775,26.478 L294.351,26.478 L294.351,43.28 L290.775,43.28 L282.806,31.951 Z M271.325,43.28 L275.094,43.28 L275.094,26.478 L271.325,26.478 L271.325,43.28 Z M255.281,43.28 L255.281,26.478 L267.642,26.478 L267.642,29.671 L258.954,29.671 L258.954,33.151 L266.442,33.151 L266.442,36.128 L258.954,36.128 L258.954,40.112 L267.883,40.112 L267.883,43.28 L255.281,43.28 Z M237.154,32.695 L237.154,43.28 L233.626,43.28 L233.626,26.478 L237.394,26.478 L242.483,36.223 L247.571,26.478 L251.147,26.478 L251.147,43.28 L247.619,43.28 L247.619,32.695 L243.347,40.759 L241.427,40.759 L237.154,32.695 Z M217.666,43.28 L217.666,26.478 L230.027,26.478 L230.027,29.671 L221.339,29.671 L221.339,33.151 L228.827,33.151 L228.827,36.128 L221.339,36.128 L221.339,40.112 L230.267,40.112 L230.267,43.28 L217.666,43.28 Z M214.543,34.159 C214.575,34.464 214.591,34.775 214.591,35.095 C214.575,37.479 213.795,39.479 212.251,41.095 C210.707,42.712 208.726,43.52 206.31,43.52 C203.814,43.52 201.73,42.696 200.057,41.048 C198.386,39.4 197.55,37.359 197.55,34.927 C197.55,32.495 198.406,30.439 200.118,28.758 C201.83,27.079 203.934,26.239 206.431,26.239 C207.263,26.239 208.051,26.327 208.795,26.503 C209.539,26.678 210.146,26.894 210.619,27.15 C211.091,27.407 211.507,27.663 211.867,27.919 C212.227,28.174 212.487,28.39 212.647,28.567 L212.863,28.831 L210.319,31.423 C210.287,31.375 210.235,31.311 210.163,31.231 C210.091,31.151 209.931,31.003 209.682,30.787 C209.434,30.571 209.171,30.382 208.89,30.222 C208.61,30.063 208.243,29.919 207.787,29.791 C207.331,29.663 206.854,29.598 206.358,29.598 C204.87,29.598 203.639,30.103 202.662,31.111 C201.686,32.119 201.198,33.383 201.198,34.903 C201.198,36.423 201.686,37.691 202.662,38.708 C203.639,39.723 204.87,40.232 206.358,40.232 C207.526,40.232 208.511,39.923 209.31,39.307 C210.111,38.691 210.615,37.855 210.823,36.799 L206.19,36.799 L206.19,34.159 L214.543,34.159 Z M186.847,25.23 L184.11,25.23 L185.719,21.198 L189.39,21.198 L186.847,25.23 Z M183.582,43.28 L187.35,43.28 L187.35,26.478 L183.582,26.478 L183.582,43.28 Z M175.892,33.679 L176.564,26.478 L180.261,26.478 L178.604,33.679 L175.892,33.679 Z M168.888,25.23 L166.151,25.23 L167.76,21.198 L171.431,21.198 L168.888,25.23 Z M164.903,36.847 L169.584,36.847 L167.256,30.678 L164.903,36.847 Z M175.992,43.28 L171.96,43.28 L170.616,39.752 L163.895,39.752 L162.551,43.28 L158.711,43.28 L165.527,26.478 L169.176,26.478 L175.992,43.28 Z M152.912,36.199 L145.592,36.199 L145.592,43.28 L141.919,43.28 L141.919,26.478 L145.592,26.478 L145.592,32.935 L152.912,32.935 L152.912,26.478 L156.56,26.478 L156.56,43.28 L152.912,43.28 L152.912,36.199 Z M128.667,36.847 L133.347,36.847 L131.019,30.678 L128.667,36.847 Z M139.756,43.28 L135.723,43.28 L134.38,39.752 L127.659,39.752 L126.314,43.28 L122.474,43.28 L129.291,26.478 L132.939,26.478 L139.756,43.28 Z M111.531,40.471 L115.155,40.471 C115.955,40.471 116.592,40.252 117.063,39.811 C117.535,39.372 117.771,38.832 117.771,38.191 C117.771,37.551 117.535,37.019 117.063,36.595 C116.592,36.172 115.955,35.96 115.155,35.96 L111.531,35.96 L111.531,40.471 Z M114.603,33.319 C115.339,33.319 115.924,33.127 116.355,32.743 C116.787,32.359 117.004,31.887 117.004,31.327 C117.004,30.751 116.787,30.271 116.355,29.886 C115.924,29.503 115.339,29.311 114.603,29.311 L111.531,29.311 L111.531,33.319 L114.603,33.319 Z M115.395,26.478 C116.979,26.478 118.256,26.879 119.223,27.678 C120.191,28.478 120.676,29.51 120.676,30.775 C120.676,31.575 120.472,32.298 120.063,32.947 C119.655,33.595 119.084,34.111 118.347,34.495 C119.307,34.815 120.059,35.343 120.603,36.08 C121.147,36.815 121.42,37.664 121.42,38.624 C121.42,39.952 120.895,41.06 119.847,41.948 C118.8,42.836 117.459,43.28 115.827,43.28 L107.858,43.28 L107.858,26.478 L115.395,26.478 L115.395,26.478 Z"
                                  id="Fill-20"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </GatsbyLink>
                    </div>
                  </div>
                  <div className="flex justify-end flex-grow lg:w-3/4 xl:w-4/5">
                    <NavLink to="/eine-aktive-gemeinde/">
                      Eine Aktive Gemeinde
                    </NavLink>
                    <NavSmallLink to="/eine-aktive-gemeinde/andachten">
                      Andachten
                    </NavSmallLink>
                    <NavSmallLink to="/eine-aktive-gemeinde/kinderklassen">
                      Kinderklassen
                    </NavSmallLink>
                    <NavSmallLink to="/eine-aktive-gemeinde/juniorjugendprogramm">
                      Juniorjugendprogramm
                    </NavSmallLink>
                    <NavSmallLink to="/eine-aktive-gemeinde/studienkreise">
                      Studienkreise
                    </NavSmallLink>
                    <NavLink to="/kontakt/">Kontakt</NavLink>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <main className="px-4 md:px-0">{children}</main>
        </div>
      </div>
      <footer className="inset-x-0 flex items-center border-t-2 border-blue-200">
        <div className="container p-4 mx-auto md:p-0">
          <div className="flex justify-start h-auto py-10 md:justify-center md:flex-col">
            <div className="flex flex-col items-start -mx-4 lg:flex-row">
              <div className="pl-6 pr-6 lg:w-1/2 xl:w-1/3">
                <div className="flex items-center">
                  <GatsbyLink
                    to="/"
                    className="text-xl leading-tight no-underline"
                  >
                    Die Bahá’í-Gemeinde in Mannheim
                  </GatsbyLink>
                </div>
              </div>
              <div className="flex flex-col justify-end w-full mt-4 md:flex-row lg:mt-0">
                <div className="pl-6 pr-6 mt-4 lg:w-1/3 xl:w-1/4 md:mt-0">
                  <Link
                    className="text-base font-semibold"
                    to="/eine-aktive-gemeinde/"
                  >
                    Eine Aktive Gemeinde
                  </Link>
                  <ul className="mt-2 text-base list-none">
                    <li>
                      <Link to="/eine-aktive-gemeinde/andachten/">
                        Andachten
                      </Link>
                    </li>
                    <li>
                      <Link to="/eine-aktive-gemeinde/kinderklassen/">
                        Kinderklassen
                      </Link>
                    </li>
                    <li>
                      <Link to="/eine-aktive-gemeinde/juniorjugendprogramm/">
                        Juniorjugendprogramm
                      </Link>
                    </li>
                    <li>
                      <Link to="/eine-aktive-gemeinde/studienkreise/">
                        Studienkreise
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="pl-6 pr-6 mt-4 lg:w-1/3 xl:w-1/4 md:mt-0">
                  <ul className="text-base list-none">
                    <li>
                      <Link to="/kontakt/">Kontakt</Link>
                    </li>
                    <li>
                      <Link to="/impressum/">Impressum</Link>
                    </li>
                    <li>
                      <Link to="/datenschutzerklaerung/">
                        Datenschutzerklärung
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="pl-6 mt-4 md:pl-10 lg:w-1/3 xl:w-1/4 md:mt-0">
                  <a
                    href="https://www.bahai.de/"
                    className="text-base font-semibold no-underline"
                  >
                    Bahá'í in Deutschland
                  </a>
                  <ul className="mt-2 text-sm list-none">
                    <li>
                      <a
                        className="no-underline"
                        href="https://www.bahai.de/haus-der-andacht/"
                      >
                        Bahá'í Haus der Andacht
                      </a>
                    </li>
                    <li>
                      <a
                        className="no-underline"
                        href="https://aktuelles.bahai.de/"
                      >
                        Aktuelles aus der deutschen und weltweiten
                        Bahá'i-Gemeinde
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default LayoutWrapper
